// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.row_W4Oi5 {
  position : relative;
  overflow : hidden !important;
  width : 100%;
  height : 32px;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-linear-view-elements/lib/Row.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,YAAY;EACZ,aAAa;AACf","sourcesContent":[".row {\n  position : relative;\n  overflow : hidden !important;\n  width : 100%;\n  height : 32px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row": `row_W4Oi5`
};
export default ___CSS_LOADER_EXPORT___;
